import React from "react";
import {Box, Heading, Form, FormField, TextInput, Button, Layer} from "grommet";
import { useLazyQuery,useMutation } from '@apollo/client';
import { tenant, tenantTypeFirstUpperCase } from "../tenant";
import { extractIdFormData} from "../../utilis/utils.js";
import {UPSERT_PRODUCT} from "./ProductGQL.jsx";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button as ButtonMui, MenuItem, Select} from "@mui/material";
import {colors, buttonStyles, layerStyles} from "../../utilis/theme.js";
import AlertDialog from "../common/AlertDialog.jsx";

// Wrapper component che gestisce la selezione dell'area prima di mostrare il form
export function AddProductWrapper(props) {
  const [showAreaDialog, setShowAreaDialog] = React.useState(false);
  const [selectedArea, setSelectedArea] = React.useState(null);
  const [showForm, setShowForm] = React.useState(false);

  React.useEffect(() => {
    // Se stiamo modificando un prodotto esistente, mostra direttamente il form
    if (props.product) {
      setShowForm(true);
      return;
    }

    // Altrimenti controlla quante aree ci sono
    const cantiereComplete = JSON.parse(sessionStorage.getItem("CantiereComplete")) || [];
    const cantiere = JSON.parse(sessionStorage.getItem("Cantiere"));
    const areeId = JSON.parse(sessionStorage.getItem("areeId"));

    // Filtra le aree che corrispondono agli ID selezionati
    let areas = [];
    if (cantiere && Array.isArray(cantiere)) {
      areas = cantiereComplete.filter(area => cantiere.includes(area.id));
    } else if (cantiere) {
      areas = cantiereComplete.filter(area => area.id === cantiere);
    } else if (areeId && Array.isArray(areeId)) {
      areas = cantiereComplete.filter(area => areeId.includes(area.id));
    }

    if (areas.length === 1) {
      // Solo un'area, usa quella automaticamente (l'ID)
      setSelectedArea(areas[0].id);
      setShowForm(true);
    } else if (areas.length > 1) {
      // Multiple aree, mostra il dialog
      setShowAreaDialog(true);
    }
  }, [props.product]);

  const handleAreaSelection = () => {
    if (selectedArea) {
      setShowAreaDialog(false);
      setShowForm(true);
    }
  };

  const handleClose = () => {
    setShowAreaDialog(false);
    if (props.onEscLayer) {
      props.onEscLayer();
    }
  };

  if (showAreaDialog) {
    const cantiereComplete = JSON.parse(sessionStorage.getItem("CantiereComplete")) || [];
    const cantiere = JSON.parse(sessionStorage.getItem("Cantiere"));
    const areeId = JSON.parse(sessionStorage.getItem("areeId"));

    // Filtra le aree che corrispondono agli ID selezionati
    let areas = [];
    if (cantiere && Array.isArray(cantiere)) {
      areas = cantiereComplete.filter(area => cantiere.includes(area.id));
    } else if (cantiere) {
      areas = cantiereComplete.filter(area => area.id === cantiere);
    } else if (areeId && Array.isArray(areeId)) {
      areas = cantiereComplete.filter(area => areeId.includes(area.id));
    }

    return (
      <Dialog open={true} onClose={handleClose}>
        <DialogTitle>Seleziona Cantiere/Area</DialogTitle>
        <DialogContent>
          <Box pad="medium" width="medium">
            <Select
              value={selectedArea || ''}
              onChange={(e) => setSelectedArea(e.target.value)}
              displayEmpty
              fullWidth
              style={{ marginTop: '10px' }}
            >
              <MenuItem value="" disabled>
                Seleziona un cantiere/area
              </MenuItem>
              {areas.map((area, index) => (
                <MenuItem key={index} value={area.id}>
                  {area.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </DialogContent>
        <DialogActions>
          <ButtonMui onClick={handleClose}>Annulla</ButtonMui>
          <ButtonMui
            onClick={handleAreaSelection}
            disabled={!selectedArea}
            variant="contained"
            style={{background:colors.primary,color:colors.white,fontWeight:'bold'}}
          >
            Conferma
          </ButtonMui>
        </DialogActions>
      </Dialog>
    );
  }

  if (showForm) {
    return <AddProduct {...props} preselectedArea={selectedArea} />;
  }

  return null;
}

export default function AddProduct(props) {

  const [formData,setFormData]=React.useState({
    area_id: props.preselectedArea || (() => {
      const cantiere = JSON.parse(sessionStorage.getItem("Cantiere"));
      const areeId = JSON.parse(sessionStorage.getItem("areeId"));
      const areas = Array.isArray(cantiere) ? cantiere : (cantiere ? [cantiere] : (areeId || []));
      return areas.length === 1 ? areas[0] : areas[0];
    })()
  });
  const [mutationAddProduct]=useMutation(UPSERT_PRODUCT);
  const [alertDialog, setAlertDialog] = React.useState({open: false, message: "", type: "success"});

  React.useEffect(()=>{
    if(props.product){
        let obj={...props.product}
        delete obj.__typename
        setFormData({...obj,area_id:JSON.parse(sessionStorage.getItem("Cantiere"))})
    }
  },[])


  const onChangeTextInput=(event)=>{
      setFormData({...formData, [event.target.name]: event.target.value})
  }

  function onUpsertProduct(){
      let formDataApp={...formData};
      if(formDataApp?.quantity || formDataApp?.quantity===0){
          delete formDataApp['quantity'];
          if(props?.product){
              delete formDataApp['area'];
              formDataApp['area_id'] = props?.product?.area?.id
          }
      }
    mutationAddProduct({variables: formDataApp})
    .then((value)=>{
      if(props?.getProducts){
          props.getProducts();
      }
      setAlertDialog({open: true, message: "Prodotto aggiunto correttamente", type: "success"});
    }).catch((value)=>{
        console.error(value);
      setAlertDialog({open: true, message: "Errore durante l'operazione", type: "error"});
    })
  }

  function onEscLayer(){
    if(props.onEscLayer){
        props.onEscLayer();
    }
    setFormData({});
  }


  return (
    <>
      <Layer onEsc={() => { if(!alertDialog.open) onEscLayer(); }} onClickOutside={() => { if(!alertDialog.open) onEscLayer(); }} style={layerStyles.dialog}>
          <Box round="16px" pad="medium" direction="column" background="white" align="center" overflow="auto" width={{min:'500px'}}>
              <Heading level="2" margin="none" size="small">
                <Box direction="row" gap="large">
                  {!props.product?"Inserisci prodotto":"Aggiorna prodotto"}
                  {/*<Button label="Scarica modello" href={"./modelliCsv/Modello_Lavoro.csv"} style={{width:'200px',fontSize:'20px',background:'#397aa3',color:'white',fontWeight:'bold',textTransform: 'uppercase',textAlign:"center"}}></Button> */}
                </Box>
              </Heading>
              <Box fill gap="medium" pad={{ vertical: "small" }}>
                <Form>
                  <Box pad="xsmall">
                        <FormField required label="Nome">
                          <TextInput
                            name="name"
                            value={ formData?.name }
                            onChange={e => onChangeTextInput(e)}
                          />
                        </FormField>
                        <FormField required label="Codice">
                          <TextInput
                            name="code"
                            value={ formData?.code }
                            onChange={e => onChangeTextInput(e)}
                          />
                        </FormField>
                        <FormField required label="Descrizione">
                          <TextInput
                            name="description"
                            value={ formData?.description }
                            onChange={e => onChangeTextInput(e)}
                          />
                        </FormField>
                        <FormField label="Unità di misura">
                          <TextInput
                            name="um"
                            placeholder="es. kg, pz, lt, m"
                            value={ formData?.um || '' }
                            onChange={e => onChangeTextInput(e)}
                          />
                        </FormField>
                        <FormField label="Prezzo per unità">
                          <TextInput
                            name="ppu"
                            type="number"
                            step="0.01"
                            value={ formData?.ppu || '' }
                            onChange={e => setFormData({...formData, ppu: e.target.value ? parseFloat(e.target.value) : null})}
                          />
                        </FormField>
                      {
                          /*
                           <FormField required label="Intervallo">
                          <TextInput
                            name="interval"
                            type="number"
                            step="0.01"
                            value={ formData?.interval }
                            onChange={e => onChangeTextInput(e)}
                          />
                        </FormField>
                          *
                          ***/
                      }

                      {
                          /*
                          * <FormField required label="Quantità">
                            <TextInput
                                name="quantity"
                                type="number"
                                step="0.01"
                                value={ formData?.quantity }
                                onChange={e => onChangeTextInput(e)}
                             />
                            </FormField>
                        * */
                      }
                  </Box>
                     <FormControlLabel control={
                            <Checkbox
                              checked={formData?.currentlyInStock}
                              onChange={(e)=>setFormData({...formData,currentlyInStock:e.target.checked})}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />} label="Attualmente in magazzino?"
                        />
                </Form>

                <Box direction="row" gap="medium" alignSelf="end" >
                  <Button margin="small" label= {!props.product?"Aggiungi":"Aggiorna"} onClick={onUpsertProduct} style={buttonStyles.primary}/>
                </Box>
              </Box>
            </Box>
      </Layer>
      <AlertDialog
          open={alertDialog.open}
          onClose={() => {
              setAlertDialog({open: false, message: "", type: "success"});
              if(alertDialog.type === "success") onEscLayer();
          }}
          message={alertDialog.message}
          type={alertDialog.type}
      />
    </>
  )
}